import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { EditarEmpresaFormData } from "../schema/editar-empresa.schema";


const detalhar = async (): Promise<any> => {
    try {
        const response = await baseApiService.get(`/company/details`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};


const editar = async (data: EditarEmpresaFormData): Promise<void> => {
    try {
        await baseApiService.put(`/company/update`, data);
    } catch (err) {
        throw errosHandler(err);
    }
};

export const EmpresaService = {
    detalhar,
    editar
};